import { DimmedText, Flex } from 'components/common/styled/common-styled';
import { useBrandCurrency } from 'hooks/useBrandCurrency';
import { currencyFormat } from 'utils';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CartItemAddOn } from 'types/cart';
import usePoints from 'hooks/usePoints';

interface CartItemAddOnsProps {
  addOn: CartItemAddOn;
  hidePrice?: boolean;
  isPayingWithPoints?: boolean;
}

const CartItemAddOns = ({
  addOn,
  hidePrice,
  isPayingWithPoints,
}: CartItemAddOnsProps) => {
  const currency = useBrandCurrency();
  const { t } = useTranslation();
  const { count: addOnTotalPoints } = usePoints(addOn.price);

  const selectedAddOnPrice = isPayingWithPoints
    ? t('pointsWithCount', { count: addOnTotalPoints })
    : currencyFormat(currency)(addOn.price);

  return (
    <Flex
      style={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
      }}
      key={addOn.id}
    >
      <DimmedText size={14}>{addOn.label}</DimmedText>
      <DimmedText size={14}>
        {addOn.price === 0 && !hidePrice
          ? t('complimentary')
          : selectedAddOnPrice}
        {` x ${addOn.selectedNumber}`}
      </DimmedText>
    </Flex>
  );
};

export default CartItemAddOns;
